var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocsColored = function SvgDocsColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M5 17.273V4a1 1 0 0 1 1-1h6.728a1 1 0 0 1 .753.342l3.272 3.74A1 1 0 0 1 17 7.74v9.533a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M13.143 7.114V3.447c0-.157.194-.232.299-.115L16.742 7c.1.11.021.286-.127.286h-3.3a.17.17 0 0 1-.172-.172Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M7.857 9.962h4.104M7.682 13.409h5.545"
  })));
};
export default SvgDocsColored;